<fv-elevated padding="md" elevation="l1" radius="sm">
  <section class="report" [attr.data-cy]="qaKeys.Report" aria-labelledby="report-title">
    <h2 id="report-title" class="report__title">{{ copy.title }}</h2>

    @if (isUnavailable()) {
      <p class="report__rest">{{ copy.unavailable }}</p>
    } @else if (renderedLines().length > 0) {
      <ul class="report__list">
        @for (line of renderedLines(); track line.key) {
          <li class="report__line" [attr.data-cy]="qaKeys.ReportLine">
            <span class="report__label">{{ line.label }}</span>
            {{ ' ' }}
            <span class="report__text" [class.report__text--gap]="line.isGap"
              >— {{ line.isGap ? copy.noDataWord : copy.unavailableWord }} {{ line.windows }}</span
            >
          </li>
        }
      </ul>
      @if (!isTruncated()) {
        <p class="report__rest">{{ copy.othersAvailable }}</p>
      }
    } @else if (!isTruncated()) {
      <p class="report__rest report__rest--ok">{{ copy.allAvailable }}</p>
    }
  </section>
</fv-elevated>
